<template>
    <v-autocomplete
        :disabled="disabled"
        :item-text="itemText"
        :item-value="itemValue"
        :items="items"
        :label="label"
        clearable
        dense
        outlined
        v-model="innerModel"
        hide-details
        :error="error"
    >
    </v-autocomplete>
</template>

<script>
export default {
    /**
     * 검색이랑 selectBox 2개다 적용하기위해 v-autocomplete를 구현했습니다.
     * selectBox 구현한 부분이랑 큰 차이는 없습니다.
     */
    name: "SearchSelectAutoComplete",
    props: {
        value: undefined,
        items: Array,
        label: {
            type: String,
            default: "Select Items",
        },
        itemValue: {
            type: String,
            default: "codeKey"
        },
        itemText: {
            type: String,
            default: "codeValue"
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        error:{
            type:Boolean,
            default:false
        },
    },
    data() {
        return {
            innerModel: null,
        }
    },
    watch: {
        innerModel(newValue, oldValue) {
            if (this.checkDirty(newValue, oldValue) !== true) return;
            this.$emit('input', newValue);
            this.$emit('update:selected',this.label);
        },
        value: {
            immediate: true,
            handler(newValue,oldValue)  {
                if (this.checkDirty(newValue, oldValue) !== true) return;//X 버튼 눌렀을때 data값 초기화
                this.innerModel = newValue;
            }
        },
    },
    methods: {
        /**
         * 처음 값이 없거나(첫 랜더링시), 나중 값이 없을때(X버튼을 눌렀을때)
         * @param newValue
         * @param oldValue
         * @returns {boolean}
         */
        checkDirty(newValue, oldValue) {
            if (newValue === undefined && oldValue !== undefined) return true;
            if (newValue === oldValue) return false;
            //if (this.items.filter(e => e[this.itemValue] === newValue).length < 1) return false;
            return true;
        },
    },
}
</script>

<style scoped>
>>> input:read-only, >>> input {
    background-color: transparent !important;
    border: 0 !important;
  font-size: 12px;
}



</style>
